import { createService } from "../../utils";
import api from "./api.json";
const initService = () => createService(api);
export { initService };
